import { Box, Typography } from "@mui/material";
import { mcaI20Logo } from "../../../Assets";

export const LivePlayerPlaceholder = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: { xs: 220, md: "22vw" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "transparent",
        px: { xs: 1, md: "1.2vw" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: { xs: 1.2, md: "1.4vw" },
          flexWrap: "nowrap",
          textAlign: "center",
        }}
      >
        <img
          src={mcaI20Logo}
          alt="T20 Mumbai"
          style={{ width: "11vw", height: "auto" }}
        />
        <Typography
          sx={{
            color: "#fff",
            fontWeight: 800,
            fontSize: { xs: "1.1rem", md: "2.5vw" },
            lineHeight: 1.1,
          }}
        >
          T20 Mumbai League - 2026
        </Typography>
      </Box>
    </Box>
  );
};
